module.exports = __webpack_public_path__ + "static/media/FDOH Logo.0db842e7.jpeg";